import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {ONLY_ON_PRIMARY_LOCALE} from './localization';
import {WHEN_NOT_IN_OPTIMIZE_MODE} from './optimization';

export const canManageEcomm = defineAbilityConfig([
  {
    permission: ['manage', 'siteCommerce'],
    features: {ecommerce: true},
    localization: ONLY_ON_PRIMARY_LOCALE,
  },
  {
    permission: ['manage', 'siteCommerce'],
    siteModes: {edit: true},
    features: {ecommerce: true},
    localization: ONLY_ON_PRIMARY_LOCALE,
  },
] as const);

export const canSetupEcomm = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
    unauthorized: true,
  },
  permission: ['manage', 'siteCommerce'],
  siteModes: {design: true},
  workflows: {canvas: true, dynamicData: true},
  localization: ONLY_ON_PRIMARY_LOCALE,
  optimization: WHEN_NOT_IN_OPTIMIZE_MODE,
} as const);

export const canViewSetupEcomm = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
  },
  permission: ['manage', 'siteCommerce'],
} as const);

// users should be able to access Ecomm panel if they:
// - have ability to setup commerce for this site
// - or if they have already setup commerce for this site and have manage permission
// - ot if they have already setup commerce for this site and are in read-only userType
export const canAccessEcommViaSetup = defineAbilityConfig({
  abilities: {canSetupEcomm: true},
  permission: ['design', 'site'],
  siteModes: {design: true, edit: true},
  optimization: WHEN_NOT_IN_OPTIMIZE_MODE,
} as const);

export const canAccessEcommViaManage = defineAbilityConfig({
  siteModes: {design: true, edit: true},
  workflows: {
    canvas: true,
    preview: true,
    logicFlows: true,
    dynamicData: true,
  },
  permissions: [
    ['manage', 'siteCommerce'],
    ['design', 'site'],
  ],
  features: {ecommerce: true},
  localization: ONLY_ON_PRIMARY_LOCALE,
  optimization: WHEN_NOT_IN_OPTIMIZE_MODE,
} as const);

export const canAccessEcommViaReadOnly = defineAbilityConfig({
  userTypes: {unauthorized: true},
  permission: ['design', 'site'],
  siteModes: {design: true, edit: true},
  features: {ecommerce: true},
  localization: ONLY_ON_PRIMARY_LOCALE,
  optimization: WHEN_NOT_IN_OPTIMIZE_MODE,
} as const);

export const canAccessEcomm = defineAbilityConfig([
  {abilities: {canAccessEcommViaSetup: true}},
  {abilities: {canAccessEcommViaManage: true}},
  {abilities: {canAccessEcommViaReadOnly: true}},
] as const);
